import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { useNavigate } from 'react-router-dom';
import { Button, message, Input, Form, Select } from 'antd';
import axios from 'axios';
import { Api_VariavelGlobal } from '../global';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import CryptoJS from 'crypto-js';

const { Option } = Select;

const UserForm = () => {
  const [TELEFONE, setTelefone] = useState('');
  const [LOGIN, setNome] = useState('');
  const [EMAIL, setEmail] = useState('');
  const [SENHA, setSenha] = useState('');
  const [REPSENHA, setRepsenha] = useState('');
  const [ID_TIPO_USUARIO, setTipoUsuario] = useState(null);
  const [STATUS, setStatus] = useState(1);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!LOGIN || !EMAIL || !TELEFONE || !SENHA || !REPSENHA || !ID_TIPO_USUARIO) {
      return message.error('Por favor, preencha todos os campos obrigatórios!');
    }
    if (SENHA !== REPSENHA) {
      return message.error('As senhas não coincidem!');
    }

    setLoading(true);
    try {
      const telefoneNumeros = TELEFONE.replace(/\D/g, '');
      const hashedPassword = CryptoJS.MD5(SENHA).toString();

      const formData = {
        LOGIN,
        EMAIL,
        TELEFONE: telefoneNumeros,
        SENHA: hashedPassword,
        REPSENHA: hashedPassword,
        ID_TIPO_USUARIO,
        STATUS,
        DATA: new Date().toISOString(),
      };

      console.log('Enviando para o backend:', formData);

      const response = await axios.post(`${Api_VariavelGlobal}/api/register`, formData);

      if (response.status === 200 || response.status === 201) {
        message.success(response.data.message || 'Usuário criado com sucesso!');
        navigate('/users'); // redireciona para lista de usurios, ajuste se quiser outra rota
      } else {
        message.error('Falha ao criar usuário.');
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      message.error(error.response?.data?.message || 'Erro ao criar usuário.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Form onFinish={handleSubmit} layout="vertical">
        <Form.Item label="Nome do Usuário" required>
          <Input
            size="large"
            placeholder="Nome do usuário"
            value={LOGIN}
            onChange={(e) => setNome(e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Telefone" required>
          <InputMask
            mask="(99) 99999-9999"
            value={TELEFONE}
            onChange={(e) => setTelefone(e.target.value)}
          >
            {() => <Input size="large" placeholder="Telefone" />}
          </InputMask>
        </Form.Item>

        <Form.Item label="Email" required>
          <Input
            size="large"
            placeholder="Email"
            value={EMAIL}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Senha" required style={{ marginBottom: 0 }}>
          <Input.Password
            size="large"
            placeholder="Senha"
            autoComplete="new-password"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            value={SENHA}
            onChange={(e) => setSenha(e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Repita a Senha" required style={{ marginBottom: 24 }}>
          <Input.Password
            size="large"
            placeholder="Repita a senha"
            autoComplete="new-password"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            value={REPSENHA}
            onChange={(e) => setRepsenha(e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Tipo de Usuário" required>
          <Select
            placeholder="Selecione o tipo de usuário"
            value={ID_TIPO_USUARIO}
            onChange={(value) => setTipoUsuario(value)}
          >
            <Option value={1}>Administrador</Option>
            <Option value={2}>Colaborador</Option>
            <Option value={3}>Vendedor</Option>
            {/* Adicione outros tipos conforme seu banco */}
          </Select>
        </Form.Item>

        <Form.Item label="Status" required>
          <Select value={STATUS} onChange={(value) => setStatus(value)}>
            <Option value={1}>Ativo</Option>
            <Option value={0}>Inativo</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" size="large" htmlType="submit" loading={loading}>
            Criar Usuário
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UserForm;
